import React from 'react'
import { Box, Paper } from '@mui/material'

import { Button, Typography } from '~components/internal'
import { shadows, spacing, typography } from '~tokens/internal'

interface SignedOutOverlayProps {
  onSignIn: () => void
}

const SignedOutOverlay: React.FC<SignedOutOverlayProps> = ({ onSignIn }) => {
  return (
    <Box
      role='dialog'
      aria-modal='true'
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        p: spacing.md,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 480,
          p: spacing.md,
          boxShadow: shadows.lg,
        }}
      >
        <Typography variant='h5' sx={{ fontWeight: typography.fontWeight.bold, mb: spacing.xs }}>
          You&apos;ve been signed out
        </Typography>
        <Typography variant='body1' sx={{ mb: spacing.md }}>
          Sign in again to continue. Any unsaved work on this page will be restored.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant='contained' onClick={onSignIn}>
            Sign In
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}

export default SignedOutOverlay
